export enum GUEST_RECEIPT_INFO_CASE {
  NOT_REQUEST_RECEIPT_INFO = '신청_안_함',
  REQUEST_RECEIPT_INFO = '신청',
  NO_RECEIPT_INFO = '정보_없음',
}
